module.exports = new __parcel__URL__("GT_P_3_008_mobile.ea6f875e.json").toString();